import '@mantine/core/styles.css';

import { MantineProvider, localStorageColorSchemeManager } from '@mantine/core';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { I18nProvider } from './i18n';
import { queryClient } from './lib/query';
import { COLOR_SCHEME_KEY, theme } from './theme';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

const colorSchemeManager = localStorageColorSchemeManager({ key: COLOR_SCHEME_KEY });

createRoot(rootEl).render(
  <StrictMode>
    <MantineProvider
      theme={theme}
      defaultColorScheme="auto"
      colorSchemeManager={colorSchemeManager}
    >
      {/* Outside the boundary and the router: the error screen and the sign-in
          screen both need the operator's language, and neither is reachable
          from inside a provider mounted below them. */}
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </QueryClientProvider>
      </I18nProvider>
    </MantineProvider>
  </StrictMode>,
);
